<template>
  <div>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button class="button_back" @click="goBack">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-buttons slot="end">
        <ion-button @click="change('userForm')" class="pill next-pill-button">
          <span class="bankverifybutton"><span>Verify/</span><span>Update</span></span>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
      <div class="container">
        <div class="auth-header">
            <div class="auth-heading">
                <h1>Bank Details</h1>
                <p class="auth-subtext">Bank Account Details!</p>
            </div>
            <div class="brand-icon">
                <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
            </div>
        </div>
      <el-form :model="formsData.userForm" :rules="formsData.userForm.rules"
        :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'" @submit.prevent="goNext('userForm')"
        @keyup.enter="goNext('userForm')">
        <el-form-item label="Bank Name" prop="bankName" :required="true">
          <el-input v-model="formsData.userForm.bankName.value" :placeholder="'Bank Name'" disabled></el-input>
        </el-form-item>
        <el-form-item label="Account Name" prop="bankAccountName" :required="true">
          <el-input v-model="formsData.userForm.bankAccountName.value" :placeholder="'Account Name'"
            disabled></el-input>
        </el-form-item>

        <el-form-item label="Account Number" prop="bankAccountNumber" :required="true">
          <el-input v-model="formsData.userForm.bankAccountNumber.value" disabled />
        </el-form-item>
        <el-form-item label="BSB" prop="bsb" :required="true">
          <el-input v-model="formsData.userForm.bsb.value" disabled />
        </el-form-item>
      </el-form>
      <div class="bg-overlay"></div>
    </div>
    </div>
    <div class="background-circles">
        <div class="circle circle-2"></div>
        <div class="circle circle-1"></div>
        <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
    </div>
  </div>
</template>
<script>
import { onMounted } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline, downloadOutline } from "ionicons/icons";
addIcons({
  "arrow-back-outline": arrowBackOutline,
  "download-outline": downloadOutline,
});
import {
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
} from "@ionic/vue";

import { useRouter } from "vue-router";
import { useStore } from "vuex";
import formHooks from "@/hooks/form/form";
import SvgIcon from '@/components/Svg/SvgIcon.vue';


export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    SvgIcon
  },
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const goBack = () => {
      $router.push({
        name: "profile",
      });
    };
    const userData = $store.getters.GET_USER_DATA;
    const userRole = userData.role;
    const billing = userData.billing;
    const formsDataArray = {
      userForm: {
        bankName: {
          value: userData.bankNameBilling ? userData.bankNameBilling : "",
        },
        bankAccountName: {
          value: billing.bankAccountName,
        },
        bsb: {
          value: billing.bankBsb,
        },
        bankAccountNumber: {
          value: billing.bankAccountNumber,
        },
        mobileNumber: {
          value: userData.mobileNumber,
        },
      },
    };

    const change = (formName) => {
      return (async () => {
        try {
          if (userData.mobileNumber) {
            await $store.dispatch(
              "VERIFY_MOBILE_BANK_ACCOUNT",
              getFormValues(formName)
            );
          }
          $router.push({
            name: "verify_mobile",
          });
        } catch (errors) {
          console.log(errors);
        }
      })();
    };

    onMounted(() => {
      setFormRefs();
      checkFormValidation("userForm", true);
    });

    const {
      checkFormValidation, // eslint-disable-line no-unused-vars
      setFormRefs,
      getFormValues,
      formsData,
    } = formHooks(formsDataArray);

    return {
      formsData,
      goBack,
      change,
      userData,
      userRole,
    };
  },
};
</script>